module.exports = __webpack_public_path__ + "img/settings-page@2x.27c94d82.png";